export default [
  //FOR VENDOR MANAGER===============================================================================


  {
    key: "Pending Approval Vendors",
    status: "Pending Approval Vendors",
    label: "Main Information",
    showInvoicePreview: false,   //this is unique to PR data
    invoiceTitle: "Vendor Pending For Approval",

    actionButtons: [
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "list",

        buttonLabel: "Back To List",
        color: 'primary',
        icon: "icon-arrow-left-circle",
        btnSize: "large",

      },

    ]

  },
  {
    key: "Approved Vendors",
    status: "Approved Vendors",
    label: "Main Information",
    showInvoicePreview: false,   //this is unique to PR data
    invoiceTitle: "",
    actionButtons: [
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "edit",

        buttonLabel: "Edit",
        color: 'warning',
        icon: "icon-edit",
        btnSize: "large",
      },
    ]

  },
  {
    key: "Rejected Vendors",
    status: "Rejected Vendors",
    label: "Main Information",
    showInvoicePreview: false,   //this is unique to PR data
    invoiceTitle: "",
    actionButtons: [

    ]

  },
  //-----------------------------------------------------------------------------------------
  //FOR VENDOR ===============================================================================
  {
    key: "profile",
    status: "New Vendors",
    label: "Main Information",
    showInvoicePreview: false,   //this is unique to PR data
    invoiceTitle: "",

    actionButtons: [
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "list",

        buttonLabel: "Back To List",
        color: 'primary',
        icon: "icon-arrow-left-circle",
        btnSize: "large",

      },
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "edit",

        buttonLabel: "Edit",
        color: 'warning',
        icon: "icon-edit",
        btnSize: "large",

      },
    ]
  },
  {
    key: "profile",
    status: "Rejected Vendors",
    label: "Main Information",
    showInvoicePreview: false,   //this is unique to PR data
    invoiceTitle: "",

    actionButtons: [
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "list",

        buttonLabel: "Back To List",
        color: 'primary',
        icon: "icon-arrow-left-circle",
        btnSize: "large",

      },
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "edit",

        buttonLabel: "Edit",
        color: 'warning',
        icon: "icon-edit",
        btnSize: "large",

      },
    ]

  },
  {
    key: "profile",
    status: "Approved Vendors",
    label: "Main Information",
    showInvoicePreview: false,   //this is unique to PR data
    invoiceTitle: "",

    actionButtons: [
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "list",

        buttonLabel: "Back To List",
        color: 'primary',
        icon: "icon-arrow-left-circle",
        btnSize: "large",

      },
      {
        buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
        eventName: "changeView",
        eventValue: "edit",

        buttonLabel: "Edit",
        color: 'warning',
        icon: "icon-edit",
        btnSize: "large",

      },
    ]

  },
  {
    key: "profile",
    status: "Pending Approval Vendors",
    label: "Main Information",
    showInvoicePreview: false,   //this is unique to PR data
    invoiceTitle: "",
    actionButtons: [

    ]

  },



]
